import React from "react";
import { LocationScope, Category } from "generated/graphql";
import { Layout } from "views/Main/Layouts";
import { AnalysisCharts } from "collections/AnalysisCharts/AnalysisCharts";
import { useTranslation } from "utilities/i18n";

export const RoomAnalysis: React.FC<{
  id: string;
  name?: string;
}> = ({ id, name }) => {
  const { t } = useTranslation();
  const { Content } = Layout;

  return (
    <Content className="room-details">
      <Content.Title>
        {t("ANALYSIS")} <p>{`| ${name || ""}`}</p>
      </Content.Title>
      <AnalysisCharts
        id={id}
        category={Category.Room}
        locationScope={LocationScope.Room}
      />
    </Content>
  );
};
